import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController, ModalController } from 'ionic-angular';

import { NotesMarketing as Notes, DokumenMarketing as Dokumen, TenderMarketing as Tender, UserMarketing as User} from '@providers/index';
import { FormPostTenderPage, DetailImagePage } from '../'

@Component({
  selector: 'page-post-tender',
  templateUrl: 'page.html'
})
export class PostTenderPage {

  akses: any = {};
  post_tender : any ;
  tender      : any = {};
  loading     : any;
  img_url     = '';
  
  constructor(
    public navCtrl    : NavController,
    public navParams  : NavParams,
    private alertCtrl : AlertController,
    private toastCtrl : ToastController,
    public loadingCtrl: LoadingController,
    public modalCtrl  : ModalController,
    public userApi    : User,
    public tenderApi   : Tender,
    public notesApi   : Notes,
    public docApi     : Dokumen
  ) {
    this.akses   = this.userApi.akses;
    this.tender  = this.navParams.get('tender');
    this.img_url = this.docApi.file_url;

    console.log("akses => ", this.akses);
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  ionViewWillEnter(){
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    this.showLoading();
    let params = {
      tender_id : this.tender.id
    }
    this.tenderApi.getPostTender(params).subscribe((resp:any) => {
      this.post_tender = resp.data;
      this.loading.dismiss();
    });
  }
  
  add() {
    let params = {
      tender_id    : this.tender.id,
      tender_title : this.tender.title
    }
    this.navCtrl.push(FormPostTenderPage, {data:params});
  }

  edit(data){
    this.navCtrl.push(FormPostTenderPage, {
      data : data
    });
  }

  detailImage(rec:any = {}){
    let detailModal = this.modalCtrl.create(DetailImagePage, {
      url_image : this.img_url+rec.generated_name,
      detail    : rec
    });
    detailModal.present();
  }

}


// WEBPACK FOOTER //
// ./src/pages/marketing/post_tender/page.ts